/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Vi använder cookies enbart för att spåra besöken på vår webbplats. Vi lagrar inga personuppgifter.',
    cookiesAccept: 'Godkänn cookies',
    cookiesDeny: 'Avböj cookies',
    tabFAQs: 'FAQ',
    tabSupport: 'Support',
    tabHistory: 'Historik',
    tabReviews: 'Berättelser',
    tabTraining: 'Utbildning',
    tabUserTraining: 'Användarutbildning',
    tabHcpTraining: 'Vårdutbildning',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Graviditet',
    tabAbout: 'Om oss',
    tabNews: 'Nyheter',
    tabCareers: 'Karriär',
    tabOrders: '',
    tabNotifications: 'Anmälningar',
};
